<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-12-15 16:05:23
 * @FilePath: \mrc-ess-fronted\src\Page\Ess\Claim\ClaimApplication\components\viewClaimItem.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-16 17:23:13
-->
<template>
  <normalDialog
    :dialog="show"
    :width="850"
    @close="closeDialog"
    :title="
      $t('label_essweb_myClaimApplication_form_dialog_viewClaimItemTitle')
    "
  >
    <template v-slot:content>
      <Taber
        :curTab="curTab"
        :items="taber"
        backgroundColor="white"
        @change="onChange"
      >
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_ClaimRecord_form_dialog_claimItemTypeLabel")
                }}</v-sheet>
                <v-select
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :items="claimTypeList"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  item-text="view_fields"
                  item-value="value_field"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :placeholder="
                    $t(
                      'label_essweb_ClaimRecord_form_dialog_claimItemTypeLabel'
                    )
                  "
                  v-model="ClaimItemData.claim_item_type_uuid"
                  single-line
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-select>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  v-model="ClaimItemData.claim_item_name"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :label="
                    $t(
                      'label_essweb_ClaimRecord_form_dialog_claimItemNameLabel'
                    )
                  "
                />
              </v-col>
              <v-col
                v-if="
                  Number(
                    propertys['is_allow_apply|is_include_pay_date']['value']
                  )
                "
              >
                <DateTimePicker
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :defaultTime="ClaimItemData.payout_utc_datetime"
                  type="date"
                  :label="
                    $t(
                      'label_essweb_ClaimRecord_form_dialog_consumptionDateLabel'
                    )
                  "
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  placeholder="YYYY/MM/DD"
                  @change="
                    (time) => {
                      ClaimItemData.payout_utc_datetime = time;
                    }
                  "
                />
              </v-col>
              <v-col v-if="Number(propertys2['is_show_claim_reason']['value'])">
                <v-sheet class="text--secondary pl-1 mrc_text_require">{{
                  $t("label_essweb_ClaimRecord_form_dialog_claimReasonLabel")
                }}</v-sheet>
                <v-select
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :items="claimReasonList"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  item-text="view_fields"
                  item-value="value_field"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  dense
                  :placeholder="
                    $t('label_essweb_ClaimRecord_form_dialog_claimReasonLabel')
                  "
                  v-model="ClaimItemData.claim_reason_uuid"
                  single-line
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-select>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  v-model="ClaimItemData.claim_item_description"
                  :label="
                    $t('label_essweb_ClaimRecord_form_dialog_descriptionLabel')
                  "
                />
              </v-col>
            </v-row> </v-form
        ></template>
        <template v-slot:content-2>
          <v-form ref="form2" lazy-validation>
            <v-row>
              <v-col
                xs="12"
                sm="12"
                md="12"
                lg="12"
                cols="12"
                v-if="
                  Number(propertys.is_allow_attachment['value']) &&
                  Number(isAllowViewAttachments)
                "
              >
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_ClaimRecord_form_dialog_attachmentLabel")
                }}</v-sheet>
                <ImgDragUpdate
                  :defaultImageList="ClaimItemData.attachments"
                  @change="(img) => (ClaimItemData.attachments = img)"
                  :disabled="!iSEdited"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  v-model="ClaimItemData.receipt_swift_number"
                  :label="
                    $t('label_essweb_ClaimRecord_form_dialog_swiftNumberLabel')
                  "
                  isNotRequire
                />
              </v-col>
              <v-col
                xs="12"
                sm="6"
                md="6"
                lg="6"
                cols="12"
                v-if="Number(propertys.is_related_to_cost_center['value'])"
              >
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_ClaimRecord_form_dialog_costCentreLabel")
                }}</v-sheet>
                <v-select
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :items="costCenter"
                  :append-icon="iSEdited ? 'arrow_drop_down' : ''"
                  item-text="view_fields"
                  item-value="value_field"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  dense
                  :placeholder="
                    $t('label_essweb_ClaimRecord_form_dialog_costCentreLabel')
                  "
                  v-model="ClaimItemData.cost_center_uuid"
                  single-line
                >
                  <template v-slot:no-data> <noContent /> </template
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-3>
          <v-form ref="form3" lazy-validation>
            <v-row>
              <!-- <v-col md="3">
                <v-sheet
                  class="mrc_text_require text--secondary pl-1 text-block text-truncate"
                  >{{
                    $t("label_essweb_ClaimRecord_form_dialog_currencyLabel")
                  }}</v-sheet
                >
                <v-select
                  :items="currencyCodes"
                  filled
                  append-icon="arrow_drop_down"
                  item-text="view_fields"
                  item-value="value_field"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  dense
                  :placeholder="
                    $t('label_essweb_ClaimRecord_form_dialog_currencyLabel')
                  "
                  v-model="ClaimItemData.actual_currency_uuid"
                  single-line
                >
          <template v-slot:no-data>
            <noContent />
          </template></v-select>
              </v-col> -->
              <v-col
                xs="12"
                sm="6"
                md="6"
                lg="6"
                cols="12"
                v-if="
                  Number(
                    propertys['is_allow_apply|is_include_actual_amount'][
                      'value'
                    ]
                  )
                "
              >
                <normalInputTextFiled
                  type="number"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  height="32"
                  :message="curMessage"
                  :rules="$GetRules(['_Number_negative'], [null])"
                  v-model="ClaimItemData.actual_amount"
                  :label="
                    $t('label_essweb_ClaimRecord_form_dialog_actualAmountLabel')
                  "
                >
                  <template v-slot:prepend-inner>
                    <v-select
                      :items="currencyCodes"
                      :filled="iSEdited"
                      height="41"
                      style="
                        width: 120px;
                        margin-top: -9px;
                        background-color: transparent;
                        box-shadow: none;
                        background: transparent;
                      "
                      class="special_input_text"
                      :class="!iSEdited ? '' : 'ml-n3'"
                      :readonly="
                        !iSEdited ||
                        !Number(propertys.is_allow_choose_currency['value'])
                      "
                      hide-details
                      :append-icon="
                        Number(propertys.is_allow_choose_currency['value']) &&
                        iSEdited
                          ? 'arrow_drop_down'
                          : ''
                      "
                      item-text="currency_code"
                      item-value="uuid"
                      :rules="$GetRules(['_Require_Rules'], [null])"
                      dense
                      :placeholder="
                        $t('label_essweb_ClaimRecord_form_dialog_currencyLabel')
                      "
                      v-model="ClaimItemData.actual_currency_uuid"
                      single-line
                    >
                      <template v-slot:no-data> <noContent /> </template
                    ></v-select>
                  </template>
                </normalInputTextFiled>
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <normalInputTextFiled
                  type="number"
                  :readonly="!iSEdited"
                  :filled="iSEdited"
                  :rules="$GetRules(['_Number_negative'], [null])"
                  v-model="ClaimItemData.claim_amount"
                  :label="
                    $t('label_essweb_ClaimRecord_form_dialog_claimAmountLabel')
                  "
                >
                  <template v-slot:prepend-inner>
                    <div
                      style="width: 120px; line-height: 40px; margin-top: -9px"
                    >
                      {{ ClaimItemData.claim_currency_code }}
                    </div>
                  </template>
                </normalInputTextFiled>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <normalInputTextFiled
                  :disabled="true"
                  type="number"
                  :filled="false"
                  :suffix="ClaimItemData.approved_amount.toString()"
                  :label="
                    $t(
                      'label_essweb_ClaimRecord_form_dialog_approvalAmountLabel'
                    )
                  "
                  isNotRequire
                >
                  <template v-slot:prepend-inner>
                    <div
                      style="width: 120px; line-height: 40px; margin-top: -9px"
                    >
                      {{ ClaimItemData.claim_currency_code }}
                    </div>
                  </template>
                </normalInputTextFiled></v-col
              >
            </v-row></v-form
          >
        </template>
      </Taber>
    </template>
    <!-- actions -->
    <template v-slot:actions>
      <CardActions
        saveBtn
        @save="toSave"
        @cancel="closeDialog"
        v-if="iSEdited"
      />
    </template>
    <!-- actions -->
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "viewClaimItem",
  computed: {
    ...mapGetters(["companyLang", "AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    claimTypeList() {
      return this.$getSelectTrans(this.claimTypeListData, "view_fields");
    },
    claimReasonList() {
      return this.$getSelectTrans(this.claimReasonListData, "view_fields");
    },
    costCenter() {
      return this.$getSelectTrans(this.costCenterData, "view_fields");
    },
    currencyCodes() {
      return this.$getSelectTrans(this.currencyCodesData, "name");
    },
    curMessage() {
      if (this.ClaimItemData.actual_amount <= 0) return "";
      return (
        this.$t(
          "label_essweb_myClaimApplication_form_dialog_exchangeRateLabel"
        ) +
        " " +
        this.ClaimItemData.claim_currency_code +
        " to " +
        this.ClaimItemData.actual_currency_code +
        " : " +
        this.exchangerate
      );
    },
  },
  props: {
    show: { default: false, type: Boolean },
    curTypeUuid: { default: "", type: [String, Number] },
    staff_uuid: { default: "", type: [String, Number] },
    curUuid: { default: "", type: [String, Number] },
    isAllowViewAttachments: { default: 0, type: [Boolean, Number] },
  },
  watch: {
    curUuid(val) {
      if (val) this.getDetail(val);
    },
    show(val) {
      if (!val) {
        this.ClaimItemData = {
          uuid: null,
          claim_item_type_uuid: "",
          claim_item_name: "",
          claim_currency_code: "",
          actual_currency_uuid: "",
          actual_currency_code: "",
          claim_currency_uuid: "",
          claim_amount: 0,
          approved_amount: 0,
          cost_center_uuid: "",
          actual_amount: 0,
          attachments: [],
          payout_utc_datetime: "",
          receipt_swift_number: "",
          claim_item_description: "",
          claim_reason_uuid: "",
        };
      }
    },
    "ClaimItemData.actual_currency_uuid": function (val) {
      if (this.currencyCodesData.length > 0 && val)
        this.ClaimItemData.actual_currency_code = this.currencyCodesData.find(
          (ele) => ele.uuid === val
        )["currency_code"];
      if (this.ClaimItemData.actual_amount > 0)
        this.getExchange(val, this.ClaimItemData.actual_amount);
    },
    "ClaimItemData.actual_amount": function (val, old) {
      if (old === 0 && val === null) return; //初始化避开转换

      if (Number(val) > 0)
        this.getExchange(this.ClaimItemData.actual_currency_uuid, Number(val));
    },
    "ClaimItemData.claim_item_type_uuid": function (val) {
      if (val) {
        this.ClaimItemData.claim_type_name = this.claimTypeListData.find(
          (ele) => ele.value_field === val
        )["view_fields"];
      }
    },
    curTypeUuid(val) {
      if (val) {
        this.getProperty();
        this.getProperty2();
        this.getClaimTypeList();
        this.getReasonList();
      }
    },
  },
  data() {
    return {
      claimTypeListData: [],
      taber: [
        "label_essweb_ClaimRecord_form_dialog_tab_claimItemLabel",
        "label_essweb_ClaimRecord_form_dialog_tab_claimDetailLabel",
        "label_essweb_ClaimRecord_form_dialog_tab_claimAmountLabel",
      ],
      propertys: {
        is_allow_apply: { value: 0 },
        is_allow_choose_currency: { value: 0 },
        is_allow_attachment: { value: 0 },
        is_related_to_cost_center: { value: 0 },
        "is_allow_apply|is_include_actual_amount": { value: 0 },
        "is_allow_apply|is_include_pay_date": { value: 0 },
        "is_allow_apply|is_include_reference_number": { value: 0 },
      },
      propertys2: {
        is_show_balance: { value: 0 },
        is_show_brought_over: { value: 0 },
        is_show_entitlement: { value: 0 },
        is_show_earned: { value: 0 },
        is_show_taken: { value: 0 },
        is_show_claim_reason: { value: 0 },
        is_show_pending: { value: 0 },
        is_allow_take_advance: { value: 0 },
        "is_allow_take_advance|take_advance_unit": { value: 0 },
      },
      iSEdited: false,
      curTab: "tab-1",
      exchangerate: "",
      costCenterData: [],
      claimReasonListData: [],
      currencyCodesData: [],
      ClaimItemData: {
        uuid: null,
        claim_item_type_uuid: "",
        claim_type_name: "",
        claim_item_name: "",
        claim_currency_code: "",
        actual_currency_uuid: "",
        actual_currency_code: "",
        claim_currency_uuid: "",
        claim_amount: 0,
        cost_center_uuid: "",
        actual_amount: 0,
        approved_amount: 0,
        attachments: [],
        payout_utc_datetime: "",
        receipt_swift_number: "",
        claim_item_description: "",
        claim_reason_uuid: "",
      },
    };
  },
  mounted() {
    if (this.curTypeUuid) {
      this.getProperty();
      this.getProperty2();
      this.getClaimTypeList();
      this.getReasonList();
    }
    this.getCostCenterList();
    this.getDefaultcurrencyList();
    this.getCurrencyList();
  },
  methods: {
    onChange: function () {
      const that = this;
      let arr = this.ClaimItemData.attachments;
      this.ClaimItemData.attachments = [];
      this.$Sleep(500).then(() => {
        that.ClaimItemData.attachments = arr;
      });
    },
    getProperty: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "x",
        url: "/claim/get-claim-transaction-type-propertys/",
        data: {
          claim_type_uuid: this.curTypeUuid,
          codes:
            "is_allow_entry,is_check_balance,over_balance_approval_uuid,is_allow_attachment,is_allow_apply|is_include_reference_number,is_allow_attachment|is_require_attachment,is_allow_choose_currency,is_allow_apply,is_allow_apply|is_support_scan_tool,is_allow_apply|is_include_actual_amount,is_allow_apply|is_include_pay_date,is_related_to_cost_center,is_allow_cancellation,is_allow_cancellation|require_cancellation_remark",
        },
        type: "client",
      }).then((res) => {
        for (let key in res.data) {
          if (res.data[key] == null) {
            res.data[key] = { value: 0 };
          }
        }
        that.propertys = res.data;
      });
    },
    getProperty2: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "x",
        url: "/claim/get-claim-type-propertys/",
        data: {
          claim_type_uuid: this.curTypeUuid,
          codes:
            "is_show_balance,is_show_brought_over,is_show_entitlement,is_show_earned,is_show_taken,is_show_pending,is_allow_take_advance,is_allow_take_advance|take_advance_unit,is_show_claim_reason",
        },
        type: "client",
      }).then((res) => {
        for (let key in res.data) {
          if (res.data[key] == null) {
            res.data[key] = { value: 0 };
          }
        }
        that.propertys2 = res.data;
      });
    },
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "x",
        url: "/claim/get-claim-item-details/",
        data: {
          uuid: uuid,
        },
        type: "client",
      }).then((res) => {
        res.data["payout_utc_datetime"] = that.$getDateTime(
          res.data["payout_utc_datetime"],
          "YYYY-MM-DD"
        );
        res.data["attachments"].map((item) => {
          item["uuid"] = item["uuid"];
          item["file_name"] = item["file_name"];
          item["path"] = item["url"];
          item["size"] = item["attachment_size"];
        });
        that.ClaimItemData = res.data;
      });
    },
    getClaimTypeList: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_claim_item_type_select",
        claim_type_uuid: this.curTypeUuid,
      }).then((res) => {
        that.claimTypeListData = res.data;
      });
    },
    getReasonList: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_claim_reason_select",
        claim_type_uuid: this.curTypeUuid,
      }).then((res) => {
        that.claimReasonListData = res.data;
      });
    },
    getCostCenterList: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_staff_cost_center_select",
        staff_uuid: this.staff_uuid,
      }).then((res) => {
        that.costCenterData = res.data;
      });
    },
    getCurrencyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_form_records",
        url: "/claim/get-claim-currency/",
        data: {
          staff_uuid: that.curAppInfo["user"]["user_id"],
        },
        type: "client",
      }).then((res) => {
        that.currencyCodesData = res.data;
      });
      // 2021-01-18改接口 BJ
      // this.$findPrompt(
      //   {
      //
      //     prompt_name: "ess_currency_select",

      //   },
      //   false
      // ).then((res) => {
      //   that.currencyCodesData = res.data;
      // });
    },
    getDefaultcurrencyList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_form_records",
        url: "/claim/get-claim-default-currency/",
        data: {
          staff_uuid: that.curAppInfo["user"]["user_id"],
        },
        type: "client",
      }).then((res) => {
        that.ClaimItemData.claim_currency_code = res.data["currency_code"];
        that.ClaimItemData.claim_currency_uuid = res.data["uuid"];
        that.ClaimItemData.actual_currency_uuid = res.data["uuid"];
        that.ClaimItemData.actual_currency_code = res.data["currency_code"];
      });
      // 2021-01-18改接口 BJ
      // this.$findPrompt(
      //   {
      //
      //     prompt_name: "ess_default_currency_select",

      //   },
      //   false
      // ).then((res) => {
      //   that.ClaimItemData.claim_currency_code = res.data[0]["view_fields"];
      //   that.ClaimItemData.claim_currency_uuid = res.data[0]["value_field"];
      //   that.ClaimItemData.actual_currency_uuid = res.data[0]["value_field"];
      //   that.ClaimItemData.actual_currency_code = res.data[0]["view_fields"];
      // });
    },
    getExchange: function (uuid, amount) {
      const that = this;
      if (!this.ClaimItemData.claim_currency_uuid) return;
      this.$Request({
        method: "POST",
        table: "x",
        url: "/claim/get-exchange-rate/",
        data: {
          original_currency_uuid: uuid,
          foreign_currency_uuid: this.ClaimItemData.claim_currency_uuid,
          actual_amount: amount,
        },
        type: "client",
      }).then((res) => {
        that.exchangerate = res.data.exchange_rate;
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
    toSave: function () {
      if (this.$refs["form"]) {
        if (!this.$refs["form"].validate()) {
          this.$showMessage({
            title: this.$t("message_essweb_form_textField_noticeTitle"),
            okText: this.$t("message_essweb_form_textField_fillInAgain"),
            text: this.$t("message_essweb_form_textField_notIncorrect_content"),
            type: "warning",
          });
          return false;
        }
      }
      if (this.$refs["form2"]) {
        if (!this.$refs["form2"].validate()) {
          this.$showMessage({
            title: this.$t("message_essweb_form_textField_noticeTitle"),
            okText: this.$t("message_essweb_form_textField_fillInAgain"),
            text: this.$t("message_essweb_form_textField_notIncorrect_content"),
            type: "warning",
          });
          return false;
        }
      }
      this.$emit("onSave", this.ClaimItemData);
    },
  },
};
</script>